import { Firestore, Auth } from "../../config/firebase";
import * as firebase from "firebase";
class Pivot {
  constructor(user) {
    this.count = 0;
  }
  checkUpvote(postID) {
    return Firestore.collection("upvotes")
      .doc(postID)
      .get()
      .then(doc => {
        if (!doc.exists) {
          return false;
        }
      });
  }

  checkUpvotebyUser(postID) {
    return Firestore.collection("users")
      .doc(Auth.currentUser.uid)
      .get()
      .then(doc => {
        if (doc.data().upvotedPosts) {
          return doc.data().upvotedPosts.findIndex(res => res == postID);
        }
        return -1;
      });
  }

  async UpVote(postID) {
    if (Auth.currentUser) {
      const res = await this.checkUpvote(postID);

      res != false ? this.UpdateUpvote(postID) : this.CreateUpvote(postID);
    }
  }

  async UpdateUpvote(postID) {
    if (Auth.currentUser && Auth.currentUser.uid) {
      this.checkUpvotebyUser(postID).then(res => {
        console.warn(res);

        if (res == -1) {
          Firestore.collection("upvotes")
            .doc(postID)
            .update({
              upvote_count: firebase.firestore.FieldValue.increment(1)
            });

          Firestore.collection("upvotes")
            .doc(postID)
            .update({
              upvotedUsers: firebase.firestore.FieldValue.arrayUnion({
                user_id: Auth.currentUser.uid
              })
            });

          Firestore.collection("users")
            .doc(Auth.currentUser.uid)
            .update({
              upvotedPosts: firebase.firestore.FieldValue.arrayUnion(postID)
            });
        }
      });
    }
  }

  CreateUpvote(postID) {
    if (Auth.currentUser && Auth.currentUser.uid) {
      Firestore.collection("upvotes")
        .doc(postID)
        .set({ upvote_count: firebase.firestore.FieldValue.increment(1) });

      Firestore.collection("upvotes")
        .doc(postID)
        .update({
          upvotedUsers: firebase.firestore.FieldValue.arrayUnion({
            user_id: Auth.currentUser.uid
          })
        });

      Firestore.collection("users")
        .doc(Auth.currentUser.uid)
        .update({
          upvotedPosts: firebase.firestore.FieldValue.arrayUnion(postID)
        })
        .then(res => console.warn(postID));
    }
  }
}

export default new Pivot();